import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '@/shared/api/queryKeys'
import { usePermissions } from '@/shared/auth/usePermissions'
import { fetchCashBranches, type CashBranch } from './cashdeskApi'

export interface CashBranches {
  all: readonly CashBranch[]
  active: readonly CashBranch[]
  /** Yagona faol filial — tanlov ko'rsatilmaydi */
  sole: CashBranch | null
  /** Ro'yxat umuman so'ralmaydi (`cash.balance.view` yo'q) — filialni server doiradan oladi */
  unknown: boolean
  isPending: boolean
  loaded: boolean
  error: unknown
}

export function useCashBranches(): CashBranches {
  const { can } = usePermissions()
  const allowed = can('cash.balance.view')
  const query = useQuery({
    queryKey: queryKeys.cashdesk.branches,
    queryFn: ({ signal }) => fetchCashBranches(signal),
    enabled: allowed,
    staleTime: 15_000,
  })
  const all = query.data ?? []
  const active = all.filter((branch) => branch.state === 'ACTIVE')
  return {
    all,
    active,
    sole: active.length === 1 ? (active[0] ?? null) : null,
    unknown: !allowed,
    isPending: allowed && query.isPending,
    loaded: query.isSuccess,
    error: query.isError ? query.error : null,
  }
}
